

function shorthandAddress(firm) {
    var out = firm.address_line1 + ", ";

    // If line1 has no digits, or if it contains a match for certain words, show line2 also
    if ((firm.address_line1.match(/\d/g) == null || firm.address_line1.match(/[a-zA-Z]/g) == null || firm.address_line1.match(/flat|floor|unit|suite|room|building|office|number/gi) != null) && firm.address_line2 != '' && firm.address_line2 != null) {
      out += firm.address_line2 + ", ";
    }

    if (firm.city != '') {
      out += firm.city + ", ";
    } else if (firm.county != '') {
      out += firm.county + ", ";
    }
    out += firm.postcode;


    return out;
  }

function checkCoordinates(a,b)
{
  var lonClose = false;
  var latClose = false;
  if (a.lon == b.lon)
    lonClose = true;
  if (a.lat == b.lat)
    latClose = true;

  if (lonClose == true && latClose == true)
    return 1;
  else
    return 0;
}

function drawMap () {
    if (typeof google == 'undefined') {
        return false;
    }

    var res = angular.element(document.body).scope().res;
    var markers = [];
    var search = angular.element(document.body).scope().search;
    var data = JSON.parse(document.getElementById('data').value).search;

    if (data.lat == 0 || data.lon == 0 || typeof data == 'undefined' || data.lat == null || data.lon == null) {
        return false;
    }

    map = new google.maps.Map(document.getElementById('map'), {
        zoom: 11,
        center: new google.maps.LatLng(data.lat, data.lon),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: 'cooperative',
        disableDefaultUI: false,
        styles: [
          {
            featureType: 'transit',
            stylers: [{visibility: "off"}]
          },
          {
            featureType: 'poi.business',
            stylers: [{visibility: "off"}]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text',
            stylers: [{visibility: "off"}]
          }
        ]
    });

    var infowindow = new google.maps.InfoWindow({
    });

    angular.element(document.body).scope().infowindow = infowindow;

    var x = new google.maps.Marker({
        position: new google.maps.LatLng(data.lat, data.lon),
        map: map,
        icon: "/storage/pins/greenpin.png"
    });

    var marker, marker2, i;

    for (i = 0; i < res.length; i++) {
        if (!res[i].visible) {
            continue;
        }

        var count = 0;

        for(j = 0; j < res.length; j++) {
          if (res[i].visible == true && res[j].visible == true) {
            count += checkCoordinates(res[i], res[j]);
          }
        }

        var markerIcon = {
          url: "/storage/pins/bluetag.png",
          labelOrigin: new google.maps.Point(19.5, 8),
        }

        if (res[i].visible == true) {
          if (count > 1) {
            if (checkForExistingMarker(markers,res[i]) == false) {
              if (count > 99) {
                fSize = 8;
              } else {
                fSize = 9;
              }

              var marker = new google.maps.Marker({
                position: new google.maps.LatLng(res[i].lat, res[i].lon),
                map: map,
                icon: markerIcon,
                lon: res[i].lon,
                lat: res[i].lat,
                label: {
                  text: count.toString(),
                  color: '#000000',
                  fontSize: fSize+'px'
                },
                stacked: count
              });
              markers.push(marker);
            }
          } else {
            var marker = new google.maps.Marker({
              position: new google.maps.LatLng(res[i].lat, res[i].lon),
              map: map,
              icon: "/storage/pins/blue.png",
              lon: res[i].lon,
              lat: res[i].lat,
              stacked: 0,
            });
            markers.push(marker);
          }
        }

        google.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {

              angular.element(document.body).scope().firmContents = [];
              angular.element(document.body).scope().selectedFirm = 0;

              for(var j = 0; j < res.length; j++)
              {
                if ((res[j].lon == marker.lon && res[j].lat == marker.lat) && res[j].visible == true)
                {
                  var contentString = '';

                  if (res[j].img_exists) {
                    if (res[j].head_office != 1) {
                      contentString += '<a href="/financial-advisers/'+res[j].slug+'/'+res[j].fca_num+'/'+res[j].office_id+'" class="result-img" style="background-image: url(\'/storage/advisers/'+res[j].fca_num+'.png?v='+Math.floor(new Date().getTime() / 1000)+'\')"></a>';
                    } else {
                      contentString += '<a href="/financial-advisers/'+res[j].slug+'/'+res[j].fca_num+'/" class="result-img" style="background-image: url(\'/storage/advisers/'+res[j].fca_num+'.png?v='+Math.floor(new Date().getTime() / 1000)+'\')"></a>';
                    }

                    if (search.method != 'town') {
                      contentString += '<div class="content-img">';
                    } else {
                      contentString += '<div class="content-img town">';
                    }
                  } else {
                    contentString += '<div class="content">';
                  }
                  contentString += '<h2 style="font-size:1rem; margin-bottom:0.5rem;">'+res[j].firm_name;
                  if (res[j].office_name != '') {
                    contentString += '<span class="office-name"> ('+res[j].office_name+')</span>';
                  }
                  if (res[j].name_shown != '') {
                    contentString += '<span class="name_shown"> ('+res[j].name_shown+')</span>';
                  }
                  if (marker.stacked > 1) {
                    contentString += '<span class="stacked-firm"> (plus '+(marker.stacked-1)+' more)</span>';
                  }
                  contentString += '</h2>';
                  contentString += '<p>'+shorthandAddress(res[j])+'</p>';
                  if (search.method != 'town') {
                    contentString += '<div class="result-dist"><i class="fa fa-map-marker"></i> <span>'+res[j].dist+'</span> mile';
                    if (res[j].dist != 1) {
                      contentString += 's';
                    }
                    contentString += ' away</div>';
                  }
                  contentString += '</div><div style="padding-left:20px" class="content">';

                  if (res[j].bio_short != null && res[j].bio_short != '') {
                    contentString += '<p class="mb1">'+res[j].bio_short+'</p>';
                  }

                  contentString += '<div class="result-badges">';
                  if ((res[j].independent == null) || (res[j].independent == 1 && res[j].indep_status != 'confirmed_indep') || (res[j].independent == 2 && res[j].indep_status != 'confirmed_rest')) {
                    contentString += '<span class="badge badge-pill badge-faded"><i class="fa fa-question-circle"></i> Independent status unconfirmed</span>';
                  }
                  if (res[j].independent == 1 && res[j].indep_status == 'confirmed_indep') {
                    contentString += '<span class="badge badge-pill badge-primary"><i class="fa fa-check-circle"></i> Confirmed Independent</span>';
                  }
                  if (res[j].independent == 2 && res[j].indep_status == 'confirmed_rest') {
                    contentString += '<span class="badge badge-pill badge-green"><i class="fa fa-check-circle"></i> Confirmed Restricted - By '+res[i].restricted_type+'</span>';
                  }
                  if (res[j].chartered_status == 'chartered') {
                    contentString += '<span class="badge badge-pill badge-gold">Chartered Financial Planners</span>';
                  }
                  if (res[j].accredited_status == 'accredited' && res[j].accredited == 1) {
                    contentString += '<span class="badge badge-pill badge-gold">Accredited Financial Planners</span>';
                  }
                  if (res[j].chartered_status != 'chartered' && res[j].chartered_indiv == true) {
                    contentString += '<span class="badge badge-pill badge-gold-hollow">Chartered Individuals</span>';
                  }
                  contentString += '</div>';

                  if (res[j].specialities != null && res[j].specialities != undefined) {
                    contentString += '<div class="result-badges">';
                    for(var k = 0; k < res[j].specialities.length; k++) {
                      contentString += '<span class="badge badge-pill badge-spec badge-'+res[j].specialities[k]+'">'+angular.element(document.body).scope().getSpecialityNameShownByName(res[j].specialities[k])+'</span>';
                    }
                    contentString += '</div>';
                  }

                  if (res[j].head_office != 1) {
                    if (res[j].office_id == null) {
                      res[j].office_id = '';
                    }
                    contentString += '<a style="float:right" href="/financial-advisers/'+res[j].slug+'/'+res[j].fca_num+'/'+res[j].office_id+'" class="mt1 btn btn-primary btn-sm"><span>View Profile</span></a>';
                  } else {
                    contentString += '<a style="float:right" href="/financial-advisers/'+res[j].slug+'/'+res[j].fca_num+'" class="mt1 btn btn-primary btn-sm"><span>View Profile</span></a>';
                  }

                  if (marker.stacked > 1) {
                    contentString += '<a class="left-arrow" onclick="angular.element(document.body).scope().prevFirm()"><i class="fa fa-chevron-left"></i></a>';
                    contentString += '<a class="right-arrow" style="cursor:pointer; right:0; top: 50%; position:absolute;" onclick="angular.element(document.body).scope().nextFirm()"><i class="fa fa-chevron-right"></i></a>';
                  }

                  contentString += '</div>';

                  angular.element(document.body).scope().firmContents.push(contentString);
                }
              }

              infowindow.setContent(angular.element(document.body).scope().firmContents[0]);
              infowindow.open(map, marker);
            }
        })(marker, i));
    }

    if (angular.element(document.body).scope().checkVisible() > 1000) {
      var numStyles = 5;
      var markerCluster = new MarkerClusterer(map, markers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', minimumClusterSize: 10});
      markerCluster.setCalculator(function(markers,numStyles) {
        var index = 0;
        var count = markers.length;

        for(var i = 0; i < markers.length; i++) {
          if (markers[i].stacked > 1)
            count += (markers[i].stacked-1);
        }

        var dv = count;
        while(dv !== 0) {
          dv = parseInt(dv / 10, 10);
          index++;
        }

        index = Math.min(index,numStyles);
        return {
          text: count,
          index: index
        };
      });
    }
}

function checkForExistingMarker(markers,result) {
  var lon = result.lon;
  var lat = result.lat;

  for(var i = 0; i < markers.length; i++) {
    if (markers[i].lon == lon && markers[i].lat == lat) {
      return true;
    }
  }

  return false;
}

function determineTop() {
  var y = window.pageYOffset;
    var val;
    var valBottom = '0px';

    if (angular.element(document.body).scope().filtering == false) {
      angular.element(document.body).scope().bodyClass = '';
    }

    if (window.innerWidth <= 800) {
      map.setOptions({'gestureHandling':'greedy'});
      if (angular.element(document.body).scope().mapView == true) {
        window.scrollTo(0,0);
        angular.element(document.body).scope().bodyClass = 'stop-scroll';
      }
    } else {
      map.setOptions({'gestureHandling':'cooperative'});
    }

    if (window.innerWidth > 1400) {
      if (y >= 140) {
        val = 0;
      } else if (y > 0 && y < 140) {
          val = (140 - y) + 'px';
      } else {
          val = '140px';
      }
    } else if (window.innerWidth > 900) {
      if (y >= 138) {
        val = 0;
      } else if (y > 0 && y < 138) {
        val = (138 - y) + 'px';
      } else {
        val = '138px';
      }
    } else {
      if (y >= 129) {
        val = 0;
      } else if (y > 0 && y < 129) {
        val = (129 - y) + 'px';
      } else {
        val = '128px';
      }
    }

    if ((y + window.innerHeight) >= (document.body.scrollHeight - 274.4)) {
      valBottom = (y + window.innerHeight)-(document.body.scrollHeight - 274.4) + 'px';
    }

    document.getElementById('map-wrap').style.top = val;
    document.getElementById('map-wrap').style.bottom = valBottom;
}

document.addEventListener("scroll", function () {
  determineTop();
});
window.addEventListener("resize", function () {
  determineTop();
  angular.element(document.body).scope().$apply();
});






app.controller('ab-search-firm', ['$scope', '$http', '$timeout', function ($scope, $http, $timeout) {
  var data = JSON.parse(document.getElementById('data').value);
  $scope.search = data.search;
  $scope.currentMaxDist = data.dist;
  $scope.selectedFirm = 1;
  $scope.filtering = false;
  $scope.mapDrawn = false;
  $scope.mapView = false;
  $scope.getResultsFailed = false;
  $scope.bodyClass = '';
  $scope.loadingMsg = '';
  $scope.res = [];
  $scope.settings = {
    dist: data.dist.toString(),
    specialities: data.specialities,
    chartered_only: data.chartered_only,
    independent_only: data.independent_only,
    selfonboarding_only: data.selfonboarding_only,
    services: data.services,
    gives_face_to_face_advice: data.gives_face_to_face_advice,
    gives_telephone_advice: data.gives_telephone_advice,
    gives_online_advice: data.gives_online_advice,
    accredited_status: data.accredited_status,
    fees_method: data.fees_method
  };
  if($scope.settings.fees_method === 0) {
      $scope.settings.fees_method = false;
  }
  $scope.page = data.page;
  $scope.pages = [];

 
  $scope.suggestions = [];
  if (data.suggested_results != undefined) {
    $scope.suggestions = data.suggested_results;
  }




  if($scope.search.method != 'firm' && $scope.search.method != 'adviser')
  {
    $http.post('/search/get-results', {
      data: {
        pcds: {
          longitude: data.pcds.longitude,
          latitude: data.pcds.latitude
        },
        method: data.method,
        query: data.query,
        orig_query: data.orig_query,
        dist: +data.dist
      }, '_token': CSRF_TOKEN
    }).then(function successCallback (data) {
      $scope.ready = true;
      $scope.res = data.data;
      $scope.updateFilters();
      $scope.returnPage();
      drawMap();
      $timeout(function() {determineTop()}, 500);
    }).catch(function (data) {
      $scope.getResultsFailed = true;
      $scope.ready = true;
      alert('Sorry, something went wrong with retrieving your results. Please try again.');
    });
  } else if ($scope.search.method != 'adviser') {
    $http.post('/search/get-results-firm', {
      data: {
        method: data.method,
        query: data.query,
        orig_query: data.orig_query
      }, '_token': CSRF_TOKEN
    }).then(function successCallback (data) {
      $scope.ready = true;
      $scope.res = data.data;
      $scope.updateFilters();
      $scope.returnPage();
      drawMap();
      $timeout(function() {determineTop()}, 500);
    }).catch(function (data) {
      $scope.getResultsFailed = true;
      $scope.ready = true;
      alert('Sorry, something went wrong with retrieving your results. Please try again.');
    });
  } else {
    $http.post('/search/get-results-adviser', {
      data: {
        method: data.method,
        query: data.query,
        orig_query: data.orig_query
      }, '_token': CSRF_TOKEN
    }).then(function (data) {
      $scope.ready = true;
      $scope.res = data.data;
      $scope.updateFilters();
      $scope.returnPage();
      drawMap();
      $timeout(function() {determineTop()}, 500);
    }).catch(function (data) {
      $scope.getResultsFailed = true;
      $scope.ready = true;
      alert('Sorry, something went wrong with retrieving your results. Please try again.');
    });
    
  }
  

  $scope.openMapView = function () {
    $scope.mapView = true;
    if (! $scope.mapDrawn) {
      setTimeout(function() {drawMap()}, 250);
      $scope.mapDrawn = true;
    }
    $timeout(function() {determineTop()}, 260);
  };

  $scope.openListView = function () {
    $scope.mapView = false;
    $scope.bodyClass = '';
  };

  $scope.shorthandAddress = function(firm) {
    return shorthandAddress(firm);

    
  };

  $scope.toggleFilters = function () {
    $scope.filtering = ($scope.filtering ? false : true);
    if ($scope.filtering == true) {
      $scope.bodyClass = 'stop-scroll';
    } else {
      if (window.innerWidth > 800) {
        $scope.bodyClass = '';
      } else {
        if($scope.mapView == false) {
          $scope.bodyClass = '';
        }
      }
    }
  };

  $scope.updateFilters = function () {
    var active = [];
    var activeServices = [];

    // Get a list of active specialities which are ticked
    for (var i=0; i<$scope.settings.specialities.length; i++) {
      if ($scope.settings.specialities[i].active === true) {
        active.push($scope.settings.specialities[i].name);
      }
    }

    // Get a list of services which are ticked
    for (var i=0; i<$scope.settings.services.length; i++) {
      if ($scope.settings.services[i].active === true) {
        activeServices.push($scope.settings.services[i].name);
      }
    }

    // Set visible to false for any firm without the ticked specialities
    for(var i=0; i<$scope.res.length; i++) {
      $scope.res[i].visible = true;

      if ($scope.res[i].dist > parseInt($scope.settings.dist)) {
        $scope.res[i].visible = false;
      }

      // if chartered filter ticked and firm not chartered, set to false
      if ($scope.res[i].chartered_status != 'chartered' && $scope.res[i].chartered_indiv != true && $scope.settings.chartered_only) {
        $scope.res[i].visible = false;
      }

      // if indep filter ticked and firm not indep, set to false
      if ($scope.res[i].independent != 1 && $scope.settings.independent_only) {
        $scope.res[i].visible = false;
      }

      // if indep filter ticked and firm does not have self onboarding, set to false
      if ($scope.res[i].selfonboarding == null && $scope.settings.selfonboarding_only) {
        $scope.res[i].visible = false;
      }

      if ($scope.res[i].gives_face_to_face_advice != 1 && $scope.settings.gives_face_to_face_advice) {
        $scope.res[i].visible = false;
      }

      if ($scope.res[i].gives_online_advice != 1 && $scope.settings.gives_online_advice) {
        $scope.res[i].visible = false;
      }

      if ($scope.res[i].gives_telephone_advice != 1 && $scope.settings.gives_telephone_advice) {
        $scope.res[i].visible = false;
      }

      if ($scope.res[i].accredited_status != 'accredited' && $scope.settings.accredited_status) {
        $scope.res[i].visible = false;
      }

      if($scope.res[i].fees_method == null && ($scope.settings.fees_method !== 0 && $scope.settings.fees_method !== false)) {
            $scope.res[i].visible = false;
      }

      if($scope.res[i].fees_method !== null && ($scope.settings.fees_method !== 0 && $scope.settings.fees_method !== false)) {
          if ($scope.res[i].fees_method !== $scope.settings.fees_method && $scope.res[i].fees_method !== 3) {
              $scope.res[i].visible = false;
          }
      }


      // Set visible to false if they dont do the searched service(s)
      for (var j=0; j<activeServices.length; j++) {
        if (_.indexOf($scope.res[i].services, activeServices[j]) == -1) {
          $scope.res[i].visible = false;
        }
      }

      for(var j=0; j<active.length; j++) {
        if (_.indexOf($scope.res[i].specialities, active[j]) == -1) {
          $scope.res[i].visible = false;
        }
      }
    }

    

    drawMap();
    $scope.setURL();

    if (active.length == 0) {
      return;
    }

    if (active.length >= 3) {
      for (var i = 0; i < $scope.settings.specialities.length; i++) {
        if ($scope.settings.specialities[i].active != true) {
          $scope.settings.specialities[i].disabled = true;
        }
      }
    }

    if (active.length < 3) {
      for (var i = 0; i < $scope.settings.specialities.length; i++) {
        $scope.settings.specialities[i].disabled = false;
      }
    }
  };

  $scope.checkFilters = function (num) {
    var active = [];

    for(var i = 0; i < $scope.settings.specialities.length; i++) {
      if ($scope.settings.specialities[i].active === true) {
        active.push($scope.settings.specialities[i].name);
      }
    }
    if ($scope.settings.chartered_only === true) {
      active.push('chartered_only');
    }
    if ($scope.settings.independent_only === true) {
      active.push('independent_only');
    }
    if ($scope.settings.selfonboarding_only === true) {
      active.push('selfonboarding_only');
    }
    if (num == 'chartered_only') {
      active.push('chartered_only');
    } else if (num == 'independent_only') {
      active.push('independent_only');
    } else if (num == 'selfonboarding_only') {
      active.push('selfonboarding_only');
    } else if (num == 'gives_face_to_face_advice') {
      active.push('gives_face_to_face_advice');
    } else if (num == 'gives_online_advice') {
      active.push('gives_online_advice');
    } else if (num == 'gives_telephone_advice') {
      active.push('gives_telephone_advice');
    } else if (num == 'accredited_status') {
      active.push('accredited_status');
    } else if (num == 'gender') {
      active.push('gender');
    } else {
      active.push($scope.settings.specialities[num].name);
    }
    var currentTracker = 0;
    var count = 0;

    if ($scope.res.length == 0) {
      return 0;
    }

    for(var i = 0; i<$scope.res.length; i++) {
      currentTracker = 1;
      for (var j = 0; j < active.length; j++) {
        if ($scope.res[i].visible == true) {
          if (_.indexOf($scope.res[i].specialities, active[j]) == -1) {
            if (active[j] == 'chartered_only') {
              if ($scope.res[i].chartered_status != 'chartered' && $scope.res[i].chartered_indiv == false) {
                currentTracker = 0;
              }
            } else if (active[j] == 'independent_only') {
              if ($scope.res[i].independent != 1) {
                currentTracker = 0;
              }
            } else if (active[j] == 'selfonboarding_only') {
              if ($scope.res[i].selfonboarding == null) {
                currentTracker = 0;
              }
            } else if (active[j] == 'gives_face_to_face_advice') {
              if ($scope.res[i].gives_face_to_face_advice != 1) {
                currentTracker = 0;
              }
            } else if (active[j] == 'gives_online_advice') {
              if ($scope.res[i].gives_online_advice != 1) {
                currentTracker = 0;
              }
            } else if (active[j] == 'gives_telephone_advice') {
              if ($scope.res[i].gives_telephone_advice != 1) {
                currentTracker = 0;
              }
            } else if (active[j] == 'accredited_status') {
              if($scope.res[i].accredited_status != 'accredited') {
                currentTracker = 0;
              }
            } else if (active[j] == 'gender') {
              if($scope.res[i].adviser_gender != 'male' || $scope.res[i].adviser_gender != 'female') {
                currentTracker = 0;
              }
            } else {
              currentTracker = 0;
            }
          }
        } else {
          currentTracker = 0;
        }

      }
      count += currentTracker;
    }

    if (num != 'chartered_only' && num != 'independent_only') {
      for (var i = 0; i < $scope.settings.specialities.length; i++) {
        if ($scope.settings.specialities[i].active === true && num == i) {
          if (count == 0) {
            $scope.settings.specialities[i].active = false;
            $scope.updateFilters();
          }
        }
      }
    }
    if ($scope.settings.chartered_only === true && num == 'chartered_only') {
      if (count == 0) {
        $scope.settings.chartered_only = false;
        $scope.updateFilters();
      }
    }
    if ($scope.settings.independent_only === true && num == 'independent_only') {
      if (count == 0) {
        $scope.settings.independent_only = false;
        $scope.updateFilters();
      }
    }
    if ($scope.settings.selfonboarding_only === true && num == 'selfonboarding_only') {
      if (count == 0) {
        $scope.settings.selfonboarding_only = false;
        $scope.updateFilters();
      }
    }
    if ($scope.settings.gives_online_advice === true && num == 'gives_online_advice') {
      if (count == 0) {
        $scope.settings.gives_online_advice = false;
        $scope.updateFilters();
      }
    }
    if ($scope.settings.gives_online_advice === true && num == 'gives_face_to_face_advice') {
      if (count == 0) {
        $scope.settings.gives_face_to_face_advice = false;
        $scope.updateFilters();
      }
    }
    if ($scope.settings.gives_online_advice === true && num == 'gives_telephone_advice') {
      if (count == 0) {
        $scope.settings.gives_telephone_advice = false;
        $scope.updateFilters();
      }
    }
    if ($scope.settings.accredited_status === true && num == 'accredited_status') {
      if (count == 0) {
        $scope.settings.accredited_status = false;
        $scope.updateFilters();
      }
    }
    if ($scope.settings.accredited_status === true && num == 'gender') {
      if (count == 0) {
        $scope.settings.gender = false;
        $scope.updateFilters();
      }
    }
    return count;
  };

  $scope.checkServices = function(name) {
    count = 0;
    if ($scope.res.length == 0) { return 0; }
    for (i=0; i<$scope.res.length; i++) {
      if ($scope.res[i].visible == true && $scope.res[i].services != null) {
        if ($scope.res[i].services.indexOf(name) != -1) {
          count++;
        }
      }
    }

    return count;
  };

  $scope.checkFees = function(type) {
    count = 0;
    if ($scope.res.length == 0) { return 0; }
      for (i=0; i<$scope.res.length; i++) {
          if ($scope.res[i].visible === true && $scope.res[i].fees_method != null) {
              if ($scope.res[i].fees_method === type || $scope.res[i].fees_method === 3) {
                count++;
              }
          }
      }
    return count;
  };

  $scope.checkGender = function(gend) {
    count = 0;
    if ($scope.res.length == 0) { return 0; }
      for (i=0; i<$scope.res.length; i++) {
          if ($scope.res[i].visible === true && $scope.res[i].gender != null) {
              if ($scope.res[i].gender === gend) {
                count++;
              }
          }
      }
    return count;
  };

  $scope.updateDist = function () {
    if (parseInt($scope.settings.dist) <= $scope.currentMaxDist) {
      $scope.updateFilters();
    } else {
      $scope.ready = false;
      data.dist = $scope.settings.dist;
      $scope.loadingMsg = 'Loading more results... Thanks for your patience.';

      $http.post('/search/get-results', {'data': data, '_token': CSRF_TOKEN})
      .then(function successCallback (data) {
        $scope.ready = true;
        $scope.res = data.data;
        $scope.currentMaxDist = $scope.settings.dist;
        $scope.updateFilters();
      }).catch(function (data) {
        $scope.ready = true;
      });
    }
  };

  $scope.uncheckAll = function () {
    $scope.settings.chartered_only = false;
    $scope.settings.independent_only = false;
    $scope.settings.selfonboarding_only = false;
    $scope.settings.gives_telephone_advice = false;
    $scope.settings.gives_online_advice = false;
    $scope.settings.gives_face_to_face_advice = false;
    $scope.settings.accredited_status = false;
    $scope.settings.fees_method = false;
    $scope.settings.gender = false;

    for(var i=0; i<$scope.settings.specialities.length; i++) {
      $scope.settings.specialities[i].active = false;
      $scope.settings.specialities[i].disabled = false;
    }

    for(var i=0; i<$scope.settings.services.length; i++) {
      $scope.settings.services[i].active = false;
      $scope.settings.services[i].disabled = false;
    }

    for(var i = 0; i<$scope.res.length; i++) {
      $scope.res[i].visible = true;
    }

    window.location.hash = '';

    $scope.settings.dist = $scope.search.dist.toString();
    $scope.updateDist();
  };

  $scope.nextFirm = function() {
    if ($scope.selectedFirm != $scope.firmContents.length-1)
      $scope.selectedFirm++;
    else
      $scope.selectedFirm = 0;
    $scope.infowindow.setContent($scope.firmContents[$scope.selectedFirm]);
  }

  $scope.prevFirm = function() {
    if ($scope.selectedFirm != 0)
      $scope.selectedFirm--;
    else
      $scope.selectedFirm = $scope.firmContents.length-1;
    $scope.infowindow.setContent($scope.firmContents[$scope.selectedFirm]);
  }

  $scope.checkVisible = function () {
    var count = 0;
    //var count = Object($scope.res).length;

    for(var i = 0; i<$scope.res.length; i++) {
      if ($scope.res[i].visible === true) {
        count++;
      }
    }

    return count;
  };

  $scope.setURL = function () {
    var pathName = window.location.pathname.split('?')[0] + '?dist='+$scope.settings.dist;
    var hash = '&';

    if ($scope.settings.independent_only)
      hash += 'independent=1&';

    if ($scope.settings.selfonboarding_only)
      hash += 'selfonboarding=1&';

    if ($scope.settings.gender)
      hash += 'gender='+$scope.settings.gender+'&';

    if ($scope.settings.chartered_only)
      hash += 'chartered=1&';

    if ($scope.settings.gives_face_to_face_advice)
      hash += 'face=1&';

    if ($scope.settings.gives_online_advice)
      hash += 'online=1&';

    if ($scope.settings.gives_telephone_advice)
      hash += 'phone=1&';

    if ($scope.settings.accredited_status)
      hash += 'accredited=1&';

    if ($scope.settings.fees_method)
      hash += 'fees_method='+$scope.settings.fees_method+'&';

    for(var i=0; i<$scope.settings.specialities.length; i++) {
      if ($scope.settings.specialities[i].active) {
        hash += $scope.settings.specialities[i].name + '=1&';
      }
    }

    for (var i=0; i<$scope.settings.services.length; i++) {
      if ($scope.settings.services[i].active) {
        hash += $scope.settings.services[i].name + '=1&';
      }
    }

    $scope.returnPage();
    if ($scope.page != 1)
    {
      hash += 'page='+$scope.page+'&';
    }

    hash = hash.slice(0, -1);
    pathName += hash;

    history.replaceState({}, "AdviserBook", pathName);
  };

  $scope.getSpecialityNameShownByName = function (key) {
    return _.filter($scope.settings.specialities, {name: key})[0].name_shown;
  };

  $scope.CreatePages = function() {
    var pages = [];
    var page = [];
    var count = 0;

    angular.forEach($scope.res,function(value,key) {
      if (count < 10)
      {
        if (value.visible === true)
        {
          page.push(value);
          count++;
        }
      } else {
        pages.push(page);
        page = [];
        count = 0;
        if (value.visible === true)
        {
          page.push(value);
          count++;
        }
      }
    });
    pages.push(page);
    if (pages[pages.length - 1].length == 0) {
      pages.pop();
    }



    return pages;
  };

  $scope.returnPage = function() {
    if ($scope.ready === true) {
      $scope.pages = $scope.CreatePages();
      if ($scope.pages.length < $scope.page) {
        $scope.page = $scope.pages.length;
      }
      $scope.page = $scope.page+'';


      return $scope.pages[$scope.page - 1];
    }
  };

  $scope.index = function() {
    var array = [];
    for(var i=0;i<$scope.pages.length;i++) {
      array.push(i);
    }

    return array;
  };

  $scope.pageChange = function(val) {
    $scope.page = (($scope.page*1)+val);
    $scope.setURL();
    window.scrollTo(0, 0);
  };

}]);


